import { initializeApp } from "firebase/app";
import {
  getFirestore,
  query,
  doc,
  getDocs,
  getDoc,
  collection,
  addDoc,
  where,
  limit,
  startAfter,
  orderBy,
  updateDoc,
  onSnapshot,
  deleteDoc,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import {
  getAuth,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider,
} from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import {
  getFunctions,
  httpsCallable,
  connectFunctionsEmulator,
} from "firebase/functions";
import { v4 } from "uuid";

var randomToken = require("random-token");

const firebaseConfig = {
  apiKey: "AIzaSyAN0xzMahKGZPbl2LZNX95Yq8QSjS6X_f0",
  authDomain: "irecycle-db.firebaseapp.com",
  projectId: "irecycle-db",
  storageBucket: "irecycle-db.appspot.com",
  messagingSenderId: "779620298448",
  appId: "1:779620298448:web:db3c939b8dc4b504ae78d5",
  measurementId: "G-DZ81BKBTNZ",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

export const registerMerchant = async function (
  displayName,
  email,
  password,
  phone,
  shift,
  address,
  profilePhoto
) {
  try {
    const createNewMerchant = httpsCallable(functions, "createNewMerchant");
    let result = await createNewMerchant({ email, password, displayName });
    const merchant = result.data;

    const q = query(
      collection(db, "merchants"),
      where("uid", "==", merchant.uid)
    );
    const querySnapShot = await getDocs(q);
    if (querySnapShot.docs.length === 0) {
      const { email, uid } = merchant;
      const createdAt = new Date();
      var dispatchNo = randomToken(16);
      const initialPassword = true;
      const token = randomToken(16);
      const accountType = "merchant";
      const profilePicturePath = `images/${profilePhoto.name + v4()} `;
      const imageRef = ref(storage, profilePicturePath);
      const res = await uploadBytes(imageRef, profilePhoto);
      const profilePictureUrl = await getDownloadURL(imageRef);
      await addDoc(collection(db, "merchants"), {
        accountType,
        displayName,
        uid,
        email,
        createdAt,
        dispatchNo,
        shift,
        address,
        phone,
        token,
        initialPassword,
        profilePictureUrl,
        profilePicturePath,
      });
    }
  } catch (err) {
    throw err;
  }
};

export const registerAdmin = async (
  displayName,
  email,
  password,
  phone,
  address,
  profilePhoto
) => {
  try {
    const createNewAdmin = httpsCallable(functions, "createNewAdmin");
    let result = await createNewAdmin({ email, password, displayName });
    const admin = result.data;

    const q = query(collection(db, "admins"), where("uid", "==", admin.uid));
    const querySnapShot = await getDocs(q);
    if (querySnapShot.docs.length === 0) {
      const { email, uid } = admin;
      const createdAt = new Date();
      const adminId = randomToken(16);
      const token = randomToken(16);
      const initialPassword = true;
      const accountType = "admin";
      const profilePicturePath = `images/${profilePhoto.name + v4()} `;
      const imageRef = ref(storage, profilePicturePath);
      const res = await uploadBytes(imageRef, profilePhoto);
      const profilePictureUrl = await getDownloadURL(imageRef);
      await addDoc(collection(db, "admins"), {
        accountType,
        displayName,
        uid,
        email,
        createdAt,
        adminId,
        token,
        address,
        phone,
        initialPassword,
        profilePictureUrl,
        profilePicturePath,
      });
    }
  } catch (err) {
    throw err;
  }
};

export const registerSuperAdmin = async (
  displayName,
  email,
  password,
  phone,
  address,
  profilePhoto
) => {
  try {
    const createNewSuperAdmin = httpsCallable(functions, "createNewSuperAdmin");
    let result = await createNewSuperAdmin({ email, password, displayName });
    const superAdmin = result.data;

    const q = query(
      collection(db, "admins"),
      where("uid", "==", superAdmin.uid)
    );
    const querySnapShot = await getDocs(q);
    if (querySnapShot.docs.length === 0) {
      const { email, uid } = superAdmin;
      const createdAt = new Date();
      const adminId = randomToken(16);
      const token = randomToken(16);
      const initialPassword = true;
      const accountType = "superAdmin";
      const profilePicturePath = `images/${profilePhoto.name + v4()} `;
      const imageRef = ref(storage, profilePicturePath);
      const res = await uploadBytes(imageRef, profilePhoto);
      const profilePictureUrl = await getDownloadURL(imageRef);
      await addDoc(collection(db, "admins"), {
        accountType,
        displayName,
        uid,
        email,
        createdAt,
        adminId,
        token,
        address,
        phone,
        initialPassword,
        profilePictureUrl,
        profilePicturePath,
      });
    }
  } catch (err) {
    throw err;
  }
};

export const confirmPickup = async (pickupId, weight, uid, amountOfBags) => {
  try {
    connectFunctionsEmulator(functions, "localhost", "5005");
    let func = httpsCallable(functions, "confirmPickup");
    let result = await func({
      pickupId,
      weight,
      uid,
      amountOfBags,
    });
  } catch (err) {
    throw err;
  }
};

export const logInWithEmailAndPassword = async (email, password) => {
  try {
    await signInWithEmailAndPassword(auth, email, password);
  } catch (err) {
    throw err;
  }
};

export const sendPasswordResetLink = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
  } catch (err) {
    throw err;
  }
};

export const profileDetails = async (admin) => {
  try {
    let data;
    const q = query(collection(db, "admins"), where("uid", "==", admin.uid));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((document) => {
      data = doc(db, "admins", document.id);
    });
    return data;
  } catch (err) {
    throw err;
  }
};

export const getMerchant = async (merchantId) => {
  try {
    let data = [];
    const q = query(
      collection(db, "merchants"),
      where("dispatchNo", "==", merchantId)
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((document) => {
      data.push(document.data());
    });
    return data;
  } catch (err) {
    throw err;
  }
};

export const createOfflineUser = async (data, profilePhoto = null) => {
  try {
    const q = query(
      collection(db, "offlineUsers"),
      where("uid", "==", data.uid)
    );

    const querySnapShot = await getDocs(q);
    if (querySnapShot.docs.length === 0) {
      const createdAt = new Date();
      if (profilePhoto) {
        const profilePicturePath = `userProfilePhotos/${
          profilePhoto.name + v4()
        } `;
        const imageRef = ref(storage, profilePicturePath);
        const res = await uploadBytes(imageRef, profilePhoto);
        const profilePictureUrl = await getDownloadURL(imageRef);
        await addDoc(collection(db, "offlineUsers"), {
          ...data,
          createdAt,
          profilePicturePath,
          profilePictureUrl,
        });
      }
      if (!profilePhoto) {
        await addDoc(collection(db, "offlineUsers"), {
          ...data,
          createdAt,
        });
      }
    } else {
      throw new Error("Document already exists");
    }
  } catch (err) {
    throw err;
  }
};

export const snapShotDataCollector = (group) => {
  const q = query(
    collection(db, group),
    orderBy("createdAt", "desc"),
    limit(10)
  );
  return q;
};

export const paginateSnapShot = (group, lastDoc) => {
  const q = query(
    collection(db, group),
    orderBy("createdAt", "desc"),
    startAfter(lastDoc),
    limit(10)
  );
  return q;
};

export const conditionalSnapShotDataCollector = (group, field, condition) => {
  const q = query(collection(db, group), where(field, "==", condition));
  return q;
};

export const getOrders = (condition) => {
  const q = query(
    collection(db, "orders"),
    where("status", "==", condition),
    orderBy("createdAt", "desc"),
    limit(10)
  );
  return q;
};

export const paginateOrders = (condition, doc) => {
  const q = query(
    collection(db, "orders"),
    where("status", "==", condition),
    orderBy("createdAt", "desc"),
    startAfter(doc),
    limit(10)
  );
  return q;
};

export const getUsers = (condition) => {
  const q = query(
    collection(db, "users"),
    where("isRegistrationComplete", "==", condition),
    orderBy("createdAt", "desc"),
    limit(10)
  );
  return q;
};

export const paginateUsers = (condition, doc) => {
  const q = query(
    collection(db, "users"),
    where("isRegistrationComplete", "==", condition),
    orderBy("createdAt", "desc"),
    startAfter(doc),
    limit(10)
  );
  return q;
};

export const dataCollector = async (group) => {
  try {
    let data = [];
    const q = query(collection(db, group));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      const check = doc.data();
      data.push(check);
    });

    return data;
  } catch (err) {
    throw err;
  }
};

export const addData = async (group, data) => {
  try {
    const q = query(collection(db, group), where("id", "==", data.id));

    const querySnapShot = await getDocs(q);
    if (querySnapShot.docs.length === 0) {
      await addDoc(collection(db, group), data);
    } else {
      throw new Error("Document already exists");
    }
  } catch (err) {
    throw err;
  }
};

export const updateData = async (group, data) => {
  try {
    let docRef;
    const q = query(collection(db, group), where("id", "==", data.id));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((document) => {
      // doc.data() is never undefined for query doc snapshots
      docRef = doc(db, group, document.id);
    });

    await updateDoc(docRef, {
      ...data,
    });
  } catch (err) {
    throw err;
  }
};

export const updateCount = async () => {
  try {
    const countRef = doc(db, "offlineUsers", "count");
    const count = await getDoc(countRef);
    const oldCount = count.data().currCount;
    const newCount = oldCount + 1;

    await updateDoc(countRef, {
      currCount: newCount,
    });

    return newCount;
  } catch (err) {
    throw err;
  }
};

export const deleteData = async (group, id) => {
  try {
    let data;
    const q = query(collection(db, group), where("id", "==", id));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((document) => {
      deleteDoc(doc(db, group, document.id));
    });
  } catch (err) {}
};

export const addDataandImage = async (group, data, photo) => {
  try {
    const q = query(collection(db, group), where("id", "==", data.id));

    const querySnapShot = await getDocs(q);
    if (querySnapShot.docs.length === 0) {
      const photoPath = `images/${photo.name + v4()} `;
      const photoRef = ref(storage, photoPath);
      const res = await uploadBytes(photoRef, photo);
      const photoUrl = await getDownloadURL(photoRef);
      await addDoc(collection(db, group), { ...data, photoPath, photoUrl });
    } else {
      throw new Error("Document already exists");
    }
  } catch (err) {
    throw err;
  }
};

export const getTimeBoundData = async (group, time) => {
  try {
    let data = [];
    const q = query(collection(db, group), where("createdAt", ">", time));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      const check = doc.data();
      data.push(check);
    });

    return data;
  } catch (err) {
    throw err;
  }
};

export const initialPasswordChange = async (
  email,
  oldPassword,
  newPassword,
  uid
) => {
  try {
    const credential = EmailAuthProvider.credential(email, oldPassword);
    await reauthenticateWithCredential(auth.currentUser, credential);
    await updatePassword(auth.currentUser, newPassword);
    let adminRef;
    const q = query(collection(db, "admins"), where("uid", "==", uid));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((document) => {
      adminRef = doc(db, "admins", document.id);
    });
    await updateDoc(adminRef, {
      initialPassword: false,
    });
  } catch (err) {
    throw err;
  }
};

export const changePassword = async (email, oldPassword, newPassword) => {
  try {
    const credential = EmailAuthProvider.credential(email, oldPassword);

    await reauthenticateWithCredential(auth.currentUser, credential);
    await updatePassword(auth.currentUser, newPassword);
  } catch (err) {
    throw err;
  }
};

export const getOfflineClientDetailsByID = async (id) => {
  try {
    let data = [];
    const q = query(collection(db, "offlineUsers"), where("id", "==", id));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((document) => {
      data.push(document.data());
    });
    return data;
  } catch (err) {
    throw err;
  }
};
